import { render, staticRenderFns } from "./Field.vue?vue&type=template&id=631ca70b&scoped=true"
import script from "./Field.vue?vue&type=script&lang=js"
export * from "./Field.vue?vue&type=script&lang=js"
import style0 from "./Field.vue?vue&type=style&index=0&id=631ca70b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631ca70b",
  null
  
)

export default component.exports